import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'PersonNameOrder';
const ENDPOINT = `/person-name-orders/`;

@Injectable({
    providedIn: 'root'
})
export class PersonNameOrderService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
